// extracted by mini-css-extract-plugin
module.exports = {"banner":"MessageBanner_banner__UqtsA"};